<template>
  <div class="select-store">
    <div class="title">
      <div class="title-text">选择门店</div>
      <div class="close" @click="bindClose">取消</div>
    </div>
    <div class="city-scroll">
      <div class="city-list">
        <div
          class="city-item"
          :class="{ 'city-item-active': active == index }"
          v-for="(item, index) in cityList"
          :key="index"
          @click="bindClick(index)"
          >{{ item.name }}</div
        >
      </div>
    </div>
    <div class="store-flex">
      <div v-for="(item, index) in storeData" :key="index">
        <div class="loading" v-if="item.loading">加载中</div>
        <van-picker
          :swipe-duration="300"
          v-show="active == index"
          :columns="item.list"
          value-key="store_name"
          @change="bindPickerChange"
        />
      </div>
    </div>
    <div class="confirm-btn" @click="bindConfirm">确定</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      default: true
    },
    //是否只展示长沙门店
    changsha: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: 0,
      defaultIndex: 0,
      cityList: [
        {
          name: '长沙',
          code: '4301'
        },
        {
          name: '南京',
          code: '3201'
        },
        {
          name: '苏州',
          code: '3205'
        }
      ],
      storeData: [
        {
          cur: 0,
          loading: false,
          list: []
        },
        {
          cur: 0,
          loading: false,
          list: []
        },
        {
          cur: 0,
          loading: false,
          list: []
        }
      ]
    }
  },
  watch: {
    show() {
      if (this.show) {
        if (!this.storeData[this.active].list.length) {
          this.getStoreList()
        }
      }
    }
  },
  created() {
    this.init()
    this.getStoreList()
  },
  computed: {
    activityData() {
      return this.$store.state.coachActivity2024.activityData
    }
  },
  methods: {
    init() {
      if (this.changsha) {
        this.cityList = [
          {
            name: '长沙',
            code: '4301'
          }
        ]
      }
      let code = this.activityData?.city_code
      if (code) {
        this.cityList.map((item, index) => {
          if (item.code == code) {
            this.active = index
          }
        })
      }
    },
    bindClick(index) {
      this.active = index
      if (!this.storeData[this.active].list.length) {
        this.getStoreList()
      }
    },
    bindClose() {
      this.$emit('close')
    },
    bindPickerChange(picker, item) {
      this.storeData[this.active].cur = item
    },
    bindConfirm() {
      this.$emit('confirm', this.storeData[this.active].cur)
    },
    async getStoreList() {
      let active = this.active
      this.storeData[active].loading = true
      let res = await this.$http
        .getApp('api/v1/AnnualCoach/getAllStore', {
          city_code: this.cityList[active].code
        })
        .catch(() => {})
      this.storeData[active].loading = false
      if (res) {
        res = res.data
        if (res && res.code == 200) {
          this.storeData[active].list = res.data
          this.storeData[this.active].cur = (res.data && res.data[0]) || null
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.select-store {
  height: 451px;
  padding: 20px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 10px 10px 0px 0px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    .title-text {
      font-weight: bold;
      font-size: 18px;
      color: #050b27;
      line-height: 25px;
    }
    .close {
      font-size: 14px;
      color: rgba(5, 11, 39, 0.8);
      line-height: 20px;
    }
  }
  .city-scroll {
    width: 100%;
    overflow-x: scroll;
    margin-bottom: 20px;
  }
  .city-list {
    display: inline-flex;
    align-items: center;
    .city-item {
      padding: 0px 20px;
      white-space: nowrap;
      height: 28px;
      font-weight: bold;
      font-size: 14px;
      color: rgba(48, 48, 56, 0.5);
      line-height: 28px;
      background: #ffffff;
      border-radius: 14px;
      border: 1px solid rgba(5, 11, 39, 0.2);
      margin-right: 10px;
    }
    .city-item-active {
      border: 1px solid #050b27;
      color: #050b27;
    }
    .city-item:last-child {
      margin-right: 0;
    }
  }
  .store-flex {
    position: relative;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    .loading {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      color: rgba(0, 0, 0, 0.5);
    }
  }
  .confirm-btn {
    text-align: center;
    height: 44px;
    background: #ff2270;
    border-radius: 22px;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 44px;
  }
  ::v-deep .van-hairline-unset--top-bottom::after {
    /* border-top: 1px solid rgba(0,0,0,0.2);
    border-bottom: 1px solid rgba(0,0,0,0.2); */

    border-image: linear-gradient(
        270deg,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0.2),
        rgba(0, 0, 0, 0)
      )
      1 1;
  }
  ::v-deep .van-picker {
    .van-picker-column__item {
      font-size: 14px;
      color: #303038;
      line-height: 20px;
    }
    .van-picker-column__item--selected {
      font-weight: bold;
      font-size: 18px;
      color: #050b27;
      line-height: 25px;
    }
  }
}
</style>
